export interface CleanOptions {
    removeNull?: boolean;
    removeUndefined?: boolean;
    removeEmptyString?: boolean;
    deep?: boolean;
}

const DEFAULT_OPTIONS: Required<CleanOptions> = {
    removeNull: true,
    removeUndefined: true,
    removeEmptyString: false,
    deep: true,
};

export function cleanObject<T>(obj: T, options?: CleanOptions): T {
    const opts = {...DEFAULT_OPTIONS, ...options};

    if (obj === null || obj === undefined) {
        return obj;
    }

    if (Array.isArray(obj)) {
        const cleanedArray = obj
            .map(item => opts.deep ? cleanObject(item, opts) : item)
            .filter(item => {
                if (opts.removeUndefined && item === undefined) return false;
                if (opts.removeNull && item === null) return false;
                return !(opts.removeEmptyString && item === "");
            });

        return cleanedArray as unknown as T;
    }

    if (typeof obj !== "object") {
        return obj;
    }

    const cleaned: Record<string, unknown> = {};

    for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {

        if (opts.removeUndefined && value === undefined) continue;
        if (opts.removeNull && value === null) continue;
        if (opts.removeEmptyString && value === "") continue;

        if (opts.deep && typeof value === "object") {
            const nested = cleanObject(value, opts);

            if (
                nested &&
                typeof nested === "object" &&
                !Array.isArray(nested) &&
                Object.keys(nested).length === 0
            ) {
                continue;
            }

            cleaned[key] = nested;
        } else {
            cleaned[key] = value;
        }
    }

    return cleaned as T;
}